module.exports = __webpack_public_path__ + "static/altana-80f33da7e516e9537feda71c456e0bab.jpg";